import { Action } from '../actions';

const defaultState = {};

export default function brand(brandState = defaultState, action) {
  switch (action.type) {
    case Action.Poi.BrandsCompleted:
      return {
        ...brandState,
        listing: action.payload.body,
        loading: false,
        saved: false,
      };
    case Action.Poi.BrandCompleted:
      return {
        ...brandState,
        brand: action.payload.body,
      };
    case Action.Poi.BrandUpdateCompleted:
      return {
        ...brandState,
        brand: action.payload.body,
      };
    case Action.Poi.BrandCreateCompleted:
      return {
        ...brandState,
        brand: action.payload.body,
        brandId: `${action.payload.body.brand_id}`,
        redirect: `${action.payload.body.brand_id ? `/poi/brand/${action.payload.body.brand_id}` : ''}`,
      };
    case Action.Poi.BrandLogoIncrementCompleted: {
      const { status, body, error } = action.payload;
      if (error || !status || status >= 400 || !body) {
        return {
          ...brandState,
          uploadStatus: 'Error: Failed to update logo version. Please try again.',
          incrementFailed: true,
        };
      }
      return {
        ...brandState,
        brand: body,
        uploadStatus: '100% Complete',
        incrementFailed: false,
      };
    }
    default:
      break;
  }
  return brandState;
}
